import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { apiUrl } from "./config/secrets";

window.Pusher = Pusher;
// Replace these with your Pusher credentials
const PUSHER_APP_KEY = process.env.REACT_APP_PUSHER_KEY;
const PUSHER_APP_CLUSTER =process.env.REACT_APP_PUSHER_CLUSTER;


const echo = new Echo({
  broadcaster: "pusher",
  key: PUSHER_APP_KEY,
  cluster: PUSHER_APP_CLUSTER,
  forceTLS: false, 
  // authEndpoint: `${apiUrl}/broadcasting/auth`, // ✅ full path
});

export default echo;
